module.exports = __webpack_public_path__ + "static/the-mythical-manmonth-411516b52b9aba3a8fc8e77568baeb19.jpg";